import { registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import localeId from "@angular/common/locales/id";
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { authInterceptor } from "./app/auth.interceptor";
import { routes } from "./app/pages/app.routes";
import { AuthService } from "./app/services/auth.service";

// Register Indonesian locale
registerLocaleData(localeId);

export function initAuth() {
  return () => {
    const auth = inject(AuthService);
    auth.initializeAuth();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(initAuth()),
    { provide: LOCALE_ID, useValue: "id-ID" },
  ],
};
